// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from './element';
import Viewer from 'v-viewer';
import 'element-ui/lib/theme-chalk/index.css';
import './permission';
import store from '@/store';
import Katex from '@/utils/katex-directive'
// import 'katex/dist/katex.min.css';
import 'viewerjs/dist/viewer.css'
import VueClipboard from 'vue-clipboard2';
import anchor from '@/utils/anchor-directive'
import scrollBar from '@/utils/scrollBar-directive'
import Router from 'vue-router'
import axios from 'axios'
import i18n from '@/i18n'//国际化
import
  {
    NuQtReason,
    NuToast
  } from '@squirrel/nut-ui'
import GlobalVariablePlugin from '@/utils/globalVariablePlugin'
import { optionalChaining } from '@/utils/index'

Vue.use(Katex);
Vue.use(Element);
Vue.use(router);
Vue.use(anchor);
Vue.use(VueClipboard);
Vue.use(scrollBar);
Vue.use(GlobalVariablePlugin);
Vue.use(Viewer,{
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.config.productionTip = false;

Vue.use(NuQtReason)
Vue.prototype.$toast = NuToast
Vue.prototype.$http = axios
Vue.prototype.$$ = optionalChaining


// register component to use
// Vue.use(ubbToHtml);

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  if (originalPush.call(this, location)) {
    return originalPush.call(this, location).catch(err => err)
  }
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
  }

console.log(process.env.NODE_ENV,'NODE_ENV')

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n, //i18n国际化
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js